import { PageBadge } from "../recordDefinition.types";

export const communicationAudiencePageBadges: PageBadge[] = [
  {
    id: "state",
    label: (record) => (record.statecode === 0 ? "Active" : "Inactive"),
    variant: (record) => (record.statecode === 0 ? "success" : "warning"),
  },
];
